// We default to the max zindex to prevent elements from overlapping with dialogs/drawers/popovers
export const CONNECT_ELEMENTS_OVERLAY_ZINDEX_DEFAULT = 2147483647;
export const CONNECT_ELEMENTS_OVERLAYS_DEFAULT = 'dialog';
/**
 * These values are used as defaults when no value is specified or can be inferred for theming
 */ export const themeValueDefaults = {
    // General colors
    colorPrimary: '#0074D4',
    colorBackground: '#FFFFFF',
    // TODO: should these be derived instead of having a default?
    buttonSecondaryColorBackground: '#EBEEF1',
    // Form Colors
    formBackgroundColor: '#FFFFFF',
    // Feedback colors
    colorDanger: '#DF1B41',
    // Badge Colors
    badgeNeutralColorText: '#545969',
    badgeSuccessColorText: '#05690D',
    badgeWarningColorText: '#A82C00',
    badgeDangerColorText: '#B3063D',
    // Borders and spacing
    buttonBorderRadius: '4px',
    formBorderRadius: '4px',
    badgeBorderRadius: '4px',
    overlayBorderRadius: '8px',
    spacingUnit: '8px',
    // Font Size
    fontSizeBase: '16px',
    // Heading typography
    headingXlFontSize: '28px',
    headingXlFontWeight: '700',
    headingXlTextTransform: 'none',
    headingLgFontSize: '24px',
    headingLgFontWeight: '700',
    headingLgTextTransform: 'none',
    headingMdFontSize: '20px',
    headingMdFontWeight: '700',
    headingMdTextTransform: 'none',
    headingSmFontSize: '16px',
    headingSmFontWeight: '700',
    headingSmTextTransform: 'none',
    headingXsFontSize: '12px',
    headingXsFontWeight: '700',
    headingXsTextTransform: 'none',
    // Body Typography
    bodyMdFontSize: '16px',
    bodyMdFontWeight: '400',
    bodySmFontSize: '14px',
    bodySmFontWeight: '400',
    // Label Typography
    labelMdFontSize: '14px',
    labelMdFontWeight: '400',
    labelMdTextTransform: 'none',
    labelSmFontSize: '12px',
    labelSmFontWeight: '400',
    labelSmTextTransform: 'none',
    // Link decoration
    actionPrimaryTextDecorationLine: 'none',
    actionPrimaryTextDecorationStyle: 'solid',
    actionPrimaryTextDecorationThickness: 'auto',
    actionSecondaryTextDecorationLine: 'underline',
    actionSecondaryTextDecorationStyle: 'solid',
    actionSecondaryTextDecorationThickness: 'auto'
};

//# sourceMappingURL=appearanceOptionsDefaults.js.map